import * as React from 'react'
import * as styles from './Header.module.scss'
import { Link } from '@amzn/dvui/dist/Link'
import Facet from './Facet'
import SeeMore from './SeeMore'
import * as cn from 'classnames'
import { FeatureSwitches } from '../../../../containers/Storefront';
import { StorefrontCarouselEditInfo, StorefrontLink } from 'DVWebNodeUtils';

interface HeaderProps {
  featureSwitches?: FeatureSwitches
  noMarginLeft?: boolean
  facetType?: string
  facetText?: string
  facetAlternateText?: string
  facetImage?: string
  text?: string
  seeMoreLink?: StorefrontLink
  seeMoreDescription?: string
  edit?: StorefrontCarouselEditInfo
  toggleEdit?: Function
  isEditActive?: boolean
  subtext?: string
  isPhablet?: boolean
}

const Header = (props: HeaderProps) => (
  <div className={cn(styles.Header,
    { [styles.noMarginLeft]: props.noMarginLeft })}>
    <div className={cn(styles.Line1, { [styles.phablet]: props.isPhablet })}>
      <Facet {...props} className={styles.Line1Content} />
      <div className={cn(styles.carouselNameRow, styles.Line1Content, {

        [styles.hasEdit]: Boolean(props.edit)
      })}>
        {props.text && (
          <h2 className={styles.title}>
            {props.text}
          </h2>
        )}
        <SeeMore {...props.seeMoreLink}
          description={props.seeMoreDescription} />
        {Boolean(props.edit) && !global.__SERVER__ &&
          (
            <Link className={cn(styles.Edit, 'tst-edit-button')}
              onClick={() => props.toggleEdit()}>
              {!props.isEditActive ? props.edit.label
                : props.edit.cancelLabel}
            </Link>
          )
        }
      </div>
    </div>
    <div className={styles.Line2}>
      {props.subtext && (
        <h3 className={styles.subtitle}>
          {props.subtext}
        </h3>
      )}
    </div>
  </div>
)

export default Header
